import { useAuthToggles } from './useAuthToggles';

export interface UseHideLogoutSankhyaRhResult {
  hideLogoutSankhyaRh: boolean;
  isLoading: boolean;
}

export const useHideLogoutSankhyaRh = (authUrl: string): UseHideLogoutSankhyaRhResult => {
  const { data, isLoading } = useAuthToggles(authUrl);

  const hideLogoutSankhyaRh = data?.t004_hide_logout_sankhyarh ?? false;

  return { hideLogoutSankhyaRh, isLoading };
};
